import {browserHistory} from 'react-router';

let commonFunctions = {

  validateOfferData: function(browsePackages, location){

    let pathnameArr = location.pathname.split('/');
    let shipmentId = pathnameArr[pathnameArr.length - 1];
    let offerData = browsePackages.offerData;
    if(offerData && !offerData.hasOwnProperty('shipmentId')){
      browserHistory.push('/shipment/' + shipmentId + '?backTo=browse');
    }else{
      return;
    }
  },

  getShipmentId: function(url){

    let urlArr = location.pathname.split('/');
    let shipmentId = urlArr[urlArr.length - 1];
    return shipmentId;

  },

  disableClear: function(browseFilterObj, sliderCheck){

    // false if all values are default

    let browseFilter = Object.assign({}, browseFilterObj);
    delete browseFilter['userLat'];
    delete browseFilter['userLong'];
    delete browseFilter['country'];
    delete browseFilter['timestamp'];
    delete browseFilter['isMapView'];
    delete browseFilter['count'];
    delete browseFilter['packageValueFrom'];
    delete browseFilter['packageValueTo'];
    delete browseFilter['delivaryLocation'];
    delete browseFilter['pickupLocation'];
    delete browseFilter['isMyTrips'];

    for (var key in browseFilter){
      if(browseFilter[key] !== ''){
        return false;
      }
    }

    if(browseFilterObj.packageValueFrom == 0 && browseFilterObj.packageValueTo == 10000 && browseFilterObj.isMyTrips == false){
      return true;
    }
    return false;

  },

  clearBrowseFilter: function(browseFilterObj){

    let browseFilter = Object.assign({}, browseFilterObj);
    // clear delivery location
    browseFilter.delivaryLat = '';
    browseFilter.delivaryLong = '';
    browseFilter.deliveryCountry = '';
    browseFilter.delivaryLocation = '';
    // clear pickup location
    browseFilter.pickUpLat = '';
    browseFilter.pickUpLong = '';
    browseFilter.pickupCountry = '';
    browseFilter.pickupLocation = '';
    // clear delivery start date
    browseFilter.delivaryFrom = '';
    // clear delivery end Date
    browseFilter.delivaryTo = '';
    // clear package size small, medium ...
    browseFilter.packageSize = '';
    // clear package value slider -> keys is always present
    browseFilter.packageValueFrom = 0;
    browseFilter.packageValueTo = 10000;
    // clear my trip as false
    browseFilter.isMyTrips = false;
    // return
    return browseFilter;

  },

  addFilterKeysToState: function(browseFilterObj){

    let browseFilter = Object.assign({}, browseFilterObj);

    if(!browseFilter.hasOwnProperty('packageValueFrom')){
      browseFilter.packageValueFrom = 0;
      browseFilter.packageValueTo = 10000;
    }

    if(!browseFilter.hasOwnProperty('delivaryLocation')){
      browseFilter.delivaryLocation = '';
      browseFilter.delivaryLat = '';
      browseFilter.delivaryLong = '';
      browseFilter.deliveryCountry = '';
    }
    if(!browseFilter.hasOwnProperty('pickupLocation')){
      browseFilter.pickupLocation = '';
      browseFilter.pickUpLat = '';
      browseFilter.pickUpLong = '';
      browseFilter.pickupCountry = '';
    }

    if(!browseFilter.hasOwnProperty('delivaryFrom')){
      browseFilter.delivaryFrom = '';
    }

    if(!browseFilter.hasOwnProperty('delivaryTo')){
      browseFilter.delivaryTo = '';
    }

    if(!browseFilter.hasOwnProperty('packageSize')){
      browseFilter.packageSize = '';
    }

    if(!browseFilter.hasOwnProperty('isMyTrips')){
      browseFilter.isMyTrips = false;
    }

    return browseFilter;

  },

  myTripHandleKeys: function(browseFilterObj){

    let browseFilter = Object.assign({}, browseFilterObj);

    if(browseFilter.hasOwnProperty('delivaryLocation')){
      browseFilter.delivaryLocation = '';
      browseFilter.delivaryLat = '';
      browseFilter.delivaryLong = '';
      browseFilter.deliveryCountry = '';
    }
    if(browseFilter.hasOwnProperty('pickupLocation')){
      browseFilter.pickupLocation = '';
      browseFilter.pickUpLat = '';
      browseFilter.pickUpLong = '';
      browseFilter.pickupCountry = '';
    }

    if(browseFilter.hasOwnProperty('delivaryFrom')){
      browseFilter.delivaryFrom = '';
    }

    if(browseFilter.hasOwnProperty('delivaryTo')){
      browseFilter.delivaryTo = '';
    }

    return browseFilter;

  }

}

module.exports = {
  commonFunctions
}



// WEBPACK FOOTER //
// app/browse_packages/browser_common.jsx